import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import cookie from 'react-cookie';

import * as AppContext from 'lib/app-context';
import { FormattedMessage } from 'react-intl'
import url from 'url';

const propTypes = {
  appContext: PropTypes.string.isRequired,
  privacy: PropTypes.shape({
    allowAdvertising: PropTypes.bool,
    allowAnalytics: PropTypes.bool,
    browserHasGpcSignal: PropTypes.bool,
  }),
  routerLocation: PropTypes.any,
};

class GlobalPrivacyControl extends Component {
  setPermissions(value) {
    const stringValue = String(value);
    cookie.save('allowAnalytics', stringValue, { path: '/' });
    cookie.save('allowAdvertising', stringValue, { path: '/' });

    window.location.reload();
  }

  redirectURI() {
    if (this.props.routerLocation.pathname !== 'undefined') {
      return '/privacy/cookie-preferences/?redirect_uri=' + this.props.routerLocation.pathname;
    }

    return '/privacy/cookie-preferences/';
  }

  renderHeader() {
    const gpcTitle = this.props.privacy.browserHasGpcSignal
      ? <FormattedMessage id="global-privacy-control.title-gpc-detected" defaultMessage="Privacy preferences applied" />
      : <FormattedMessage id="global-privacy-control.title-gpc-not-detected" defaultMessage="We value your privacy" />;

    return this.props.appContext === AppContext.MOBILE
      ? (<div className="content-header-mobile">
            {gpcTitle}
            <div
              className="iconified-font iconified-x text-size-18 text-color-blue text-color-hover-blue clickable"
              onClick={() => this.setPermissions(false)}
              type="button"
            />
          </div>)
      : (<div>
          <div className="content-header-close">
            <div
              className="padding-top-20 padding-right-20 iconified-font iconified-x text-size-18 text-color-blue text-color-hover-blue clickable"
              onClick={() => this.setPermissions(false)}
              type="button"
            />
          </div>
          <div className="content-header">{gpcTitle}</div>
        </div>)
  }

  renderGPCContent() {
    const className = this.props.appContext === AppContext.MOBILE
      ? "content-text-mobile"
      : "content-text"

    return this.props.privacy.browserHasGpcSignal
      ? (
          <div className={className}>
            <FormattedMessage id="global-privacy-control.content-gpc-detected" defaultMessage="We detected your Global Privacy Control (GPC) signal and have set your preferences to Opt-out of all optional cookies." />
          </div>
        )
      : (
          <div className={className}>
            <FormattedMessage
              id="global-privacy-control.content-gpc-not-detected"
              defaultMessage="This website uses cookies to enhance user experience, analyze performance, and  for advertising purposes.
              Any opt-out preference signal detected will be honored.
              Further information is available in our {privacyPolicyLink}."
              values={{
                privacyPolicyLink:(
                <a href="https://www.flashparking.com/legal/privacy-policy/" target="_blank" className="text-decoration-underline" >
                  <FormattedMessage id="global-privacy-control.privacy-link" defaultMessage="Privacy Policy" />
                </a>)
              }}
            />
          </div>
        )
  }

  renderGpcButtons() {
    const buttonClassName = "btn-primary btn-bp clickable btn-modal"
    const linkToPreferences = this.redirectURI();

    const managePreferencesButton = (
      <a href={linkToPreferences} className="link-modal">
        <div className="btn-alternate btn-bp clickable btn-modal"><FormattedMessage id="global-privacy-control.btn-manage-preferences" defaultMessage="Manage preferences" /></div>
      </a>)
    const confirmAndClose = (
      <div className={buttonClassName} onClick={() => this.setPermissions(false)}>
        <FormattedMessage id="global-privacy-control.btn-confirm-and-close" defaultMessage="Confirm and close" />
      </div>)
    const acceptAll = (
      <div className={buttonClassName} onClick={() => this.setPermissions(true)}>
        <FormattedMessage id="global-privacy-control.btn-accept-all" defaultMessage="Accept all" />
      </div>)
    const declineOptionals = (
      <div className={buttonClassName} onClick={() => this.setPermissions(false)}>
        <FormattedMessage id="global-privacy-control.btn-decline-optional-cookies" defaultMessage="Decline optional cookies" />
      </div>)

    if(this.props.appContext === AppContext.MOBILE){
      if (this.props.privacy.browserHasGpcSignal) {
        return (
          <div className="content-buttons-mobile">
            {confirmAndClose}
          </div>
        )
      }
      return (
        <div className="content-buttons-mobile">
          {acceptAll}
          {declineOptionals}
          {managePreferencesButton}
        </div>
      )
    } else {
      if (this.props.privacy.browserHasGpcSignal) {
        return (
          <div className="content-buttons-inline">
            {confirmAndClose}
          </div>
        )
      }
      return (
        <div>
          <div className="content-buttons-inline">
            {acceptAll}
            {declineOptionals}
          </div>
          <div className="content-buttons-block">
            {managePreferencesButton}
          </div>
        </div>
      )
    }
  }

  render() {
    const contentClassName = this.props.appContext === AppContext.MOBILE
      ? "content-mobile"
      : "content"

    // Has any value on flags, user already configured
    if (
      this.props.privacy.allowAdvertising != null &&
      this.props.privacy.allowAnalytics != null
    ) {
      // Has no GPC (show nothing)
      if(!this.props.privacy.browserHasGpcSignal) {
        return null
      }

      // Has GPC signal and correct flags (show nothing)
      if (
        this.props.privacy.browserHasGpcSignal &&
        !this.props.privacy.allowAdvertising &&
        !this.props.privacy.allowAnalytics
      ) {
        return null
      }
    }

    // Has incorrect values for GPC signal or no configuration (show modal), configure user
    return (
      <div id="gpcModal" className={"gpc-modal"} tabIndex="-1" role="dialog">
        <div className={contentClassName}>
          { this.renderHeader() }
          { this.renderGPCContent() }
          { this.renderGpcButtons() }
        </div>
      </div>
    );
  }
}

GlobalPrivacyControl.propTypes = propTypes;
export default GlobalPrivacyControl;
